export const Status = {
  /** Tutorial has not started. */
  Idle: 'idle' as const,

  /** Tutorial is currently in progress. */
  Active: 'active' as const,

  /** Tutorial has completed, from start to finish. */
  Completed: 'completed' as const,

  /** Tutorial was dismissed somewhere during the steps. */
  Dismissed: 'dismissed' as const,
} as const;

export const Errors = {
  /** User took an invalid action. Typically used for UI, to show error content. */
  Invalid: 'invalid' as const,
} as const;

export const Modes = {
  /**
   * A tutorial with a series of steps that follow one after another until
   * completion.
   */
  Sequence: 'sequence' as const,

  /**
   * A tutorial with a series of steps that can be completed in any order.
   * Completion is determined by finishing all the steps.
   */
  Checklist: 'checklist' as const,
} as const;
